import { RenderUnsettledUI } from 'shared/components';
import { GetCompanyGrossHourlyRateResponse } from 'hq/services/company-service.types';
import { Box, styled } from '@mui/material';
import { LwButton } from 'redesign';
import { useHqRelativePath } from 'hq/hooks/useHqRelativePath';
import { useNavigateWithCompanyFilter } from 'hq/components/views/companies/hooks/use-navigate-with-company-filter';
import { CompanyGrossHourlyRateTable } from './components/company-gross-hourly-rate-table/company-gross-hourly-rate-table';
import { useGetCompanyGrossHourlyRates } from './hooks/use-get-company-gross-hourly-rates';
import { routes } from '../../../../../../../../../Routes';

export const CompanyGrossHourlyRateDataProvider = ({ id }: { id: string }) => {
  const query = useGetCompanyGrossHourlyRates(id);

  if (query.status !== 'success') {
    return <RenderUnsettledUI data={query} />;
  }

  return <CompanyGrossHourlyRate data={query.data} id={id} />;
};

const CompanyGrossHourlyRate = ({
  data,
  id,
}: {
  data: GetCompanyGrossHourlyRateResponse;
  id: string;
}) => {
  const generatePath = useHqRelativePath();
  const navigateWithCompanyFilter = useNavigateWithCompanyFilter();

  return (
    <>
      <LwButton
        onClick={() => {
          navigateWithCompanyFilter(generatePath(routes.CompanyGrossHourlyRateCreate, { id: id }));
        }}
        color="primary"
      >
        Bruto uurloon aanmaken
      </LwButton>
      <TableBox>
        <CompanyGrossHourlyRateTable data={data} />
      </TableBox>
    </>
  );
};

const TableBox = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(5),
}));
